import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
    LOCALE_ID,
    NgModule,
    CUSTOM_ELEMENTS_SCHEMA,
    provideZoneChangeDetection
} from "@angular/core";

import { HTTP_INTERCEPTORS, HttpResponse, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

import { RouterModule, PreloadAllModules } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { MatRadioModule } from "@angular/material/radio";
import {
    MatDialogRef,
    MatDialog,
    MatDialogModule
} from "@angular/material/dialog";

import { MatTabNav, MatTabLink, MatTabsModule } from '@angular/material/tabs';
import { MatTooltip, TooltipPosition, MatTooltipModule } from '@angular/material/tooltip';
import { DateAdapter, MatNativeDateModule, MAT_DATE_LOCALE, MatRippleModule } from '@angular/material/core';
import { MatProgressSpinnerModule, MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { SNACK_BAR_POSITION } from './modules_v2/shared/services/notification.service';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatStepperModule } from '@angular/material/stepper';

import { PaginationModule } from "ngx-bootstrap/pagination";

import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";

/** Shared */
import { MyDateAdapter } from "./shared/mydateadapter";
import { FilterPipe } from "./shared/filter.pipe";
import { TaxCalculator } from "./shared/taxCalculator";
import { TableComponent } from "./shared/components/table/table.component";
import { HeaderTabsModule } from "./shared/components/header-tabs/header-tabs.module";
import { AddFileComponent } from "./shared/components/add-file/add-file.component";
import { ConboxDialogComponent } from "../app/shared/components/add-file/dialog-conbox.component";
import { AddFileService } from "../app/shared/components/add-file/add-file.service";
//import { DialogComponent } from './shared/components/dialog/dialog.component';
//import { DialogService } from './shared/components/dialog/dialog.service';

import { AuthService } from "./core/guards/auth/auth.service";
import { AuthGuard } from "./core/guards/auth/auth-guard.service";
import { CONVFACT_ROUTES } from "./modules/routes";

import { AppComponent } from "./app.component";
import { NotFoundComponent } from "./core/guards/not-found/not-found.component";
import { CoreComponent } from "./core/header/core.component";
import { CoreService } from "./core/header/core.service";
import { LoginComponent } from "./core/authentication/login/login.component";
import { LogoutComponent } from "./core/authentication/logout/logout.component";
import { ForgotComponent } from "./core/authentication/forgot/forgot.component";
import { ActivateService } from "./core/authentication/activate/activate.service";
import { RegisterComponent } from "./core/authentication/register/register.component";
import { DevelopersComponent } from "./core/developers/developers.component";
import { CodeBlockComponent } from "./shared/components/code-block/code-block.component";

import { ResumeComponent } from "./modules/resume/resume.component";
import { ResumeDialogComponent } from "./modules/resume/resume-dialog.component";
import { ResumeService } from "./modules/resume/resume.service";
import { BalanceDialogComponent } from "./modules/resume/balance/balance-dialog.component";

import { HelpTabsComponent } from "./modules/help/help-tabs.component";
import { EntranceHelpComponent } from "./modules/help/entrance/entrance-help.component";
import { ExpenseHelpComponent } from "./modules/help/expense/expense-help.component";
import { BankAccountHelpComponent } from "./modules/help/bank-account/bank-account-help.component";

/*Concepts */
import { ConceptTabsComponent } from "./modules/concept/concept-tabs.component";
import { ConceptService } from "./modules/concept/concept/concept.service";
import { ConceptFamilyService } from "./modules/concept/conceptfamily/conceptfamily.service";
import { ConceptContactComponent } from "./modules/concept/conceptcontact/conceptcontact.component";
import { ConceptContactFormComponent } from "./modules/concept/conceptcontact/conceptcontact-form.component";
import { ConceptContactListComponent } from "./modules/concept/conceptcontact/conceptcontact-list.component";
import { ConceptContactService } from "./modules/concept/conceptcontact/conceptcontact.service";

import { ContactListComponent } from "./modules/contact/contact/contact-list.component";
import { ContactTabsComponent } from "./modules/contact/contact-tabs.component";
import { ContactService } from "./modules/contact/contact/contact.service";
import { ContactInvoicesComponent } from "./modules/contact/contact/contact-invoices.component";
import { ContactDialogDeleteComponent } from "./modules/contact/contact/contact-dialog-delete.component";
import { ContactImportComponent } from "./modules/contact/contact/contact-import.component";
import { BookingContactSyncDialogComponent } from "./modules/contact/contact/booking-contact-sync-dialog.component";
import { BookingConceptSyncDialogComponent } from "./modules/concept/concept/booking-concept-sync-dialog.component";

import { CenterListComponent } from "./modules/contact/center/center-list.component";
import { CenterFormComponent } from "./modules/contact/center/center-form.component";
import { CenterComponent } from "./modules/contact/center/center.component";
import { CenterService } from "./modules/contact/center/center.service";

import { PreinvoiceListComponent } from "./modules/invoice/preinvoice/preinvoice-list.component";
import { PreinvoiceFormComponent } from "./modules/invoice/preinvoice/preinvoice-form.component";
import { PreinvoiceService } from "./modules/invoice/preinvoice/preinvoice.service";
import { PreinvoiceFormItemComponent } from "./modules/invoice/preinvoice/preinvoice-form-item.component";
import { ChipsComponent } from "./shared/components/chips/chips.component";
import { PreinvoiceDialogDeleteComponent } from "./modules/invoice/preinvoice/preinvoice-dialog-delete.component";

import { DeliveryNoteService } from "./modules/invoice/deliverynotes/deliverynote.service";

import { UserContactService } from "./modules/user/usercontact/usercontact.service";
import { UserService } from "./modules/user/user.service";

import { FilesListComponent } from "./modules/file/files-list.component";
import { FilesService } from "./modules/file/files.service";
import { FilesDialogComponent } from "./modules/file/files-dialog.component";
import { FilesDialogFileComponent } from "./modules/file/files-dialog-file.component";
import { FilesDialogEditComponent } from "./modules/file/files-dialog-edit.component";
import { FilesDialogDeleteComponent } from "./modules/file/files-dialog-delete.component";

import { UserLogoComponent } from "./modules/user/usercontact/userlogo.component";

import { UserBillingListComponent } from "./modules/user/usercontact/userbilling-list.component";

import { UserCompanyService } from "./modules/user/usercompany/usercompany.service";

import { UserStockFormComponent } from "./modules/user/userStock/userStock-form.component";
import { UserStockComponent } from "./modules/user/userStock/userStock.component";
import { UserStockLoginComponent } from "./modules/user/userStock/userStock-login.component";
import { UserStockService } from "./modules/user/userStock/userStock.service";

import { BankAccountListComponent } from "./modules/finanzas/bancos/bankaccount-list.component";
import { BankAccountFormComponent } from "./modules/finanzas/bancos/bankaccount-form.component";
import { BankAccountComponent } from "./modules/finanzas/bancos/bankaccount.component";
import { BankAccountService } from "./modules/finanzas/bancos/bankaccount.service";

import { PaymentCardFormComponent } from "./modules/finanzas/paymentcard/paymentcard-form.component";
import { PaymentCardComponent } from "./modules/finanzas/paymentcard/paymentcard.component";
import { PaymentCardService } from "./modules/finanzas/paymentcard/paymentcard.service";

import { ContactBankAccountListComponent } from "./modules/contact/contactbankaccounts/contactbankaccount-list.component";
import { ContactBankAccountFormComponent } from "./modules/contact/contactbankaccounts/contactbankaccount-form.component";
import { ContactBankAccountComponent } from "./modules/contact/contactbankaccounts/contactbankaccount.component";
import { ContactBankAccountService } from "./modules/contact/contactbankaccounts/contactbankaccount.service";

import { InvoiceTabsComponent } from "./modules/invoice/invoice-tabs.component";
import { BookingTabsComponent } from "./modules_v2/booking/booking-tabs.component";
import { InvoiceListIssuedComponent } from "./modules/invoice/invoice/invoice-list-issued.component";
import { InvoiceService } from "./modules/invoice/invoice/invoice.service";
import { InvoiceDialogPaidedComponent } from "./modules/invoice/invoice/invoice-dialog-paided.component";
import { InvoiceDialogSepaComponent } from "./modules/invoice/invoice/invoice-dialog-sepa.component";
import { InvoiceDialogFacturaEComponent } from "./modules/invoice/invoice/invoice-dialog-facturae.component";
import { InvoiceDialogRectificationComponent } from "./modules/invoice/invoice/invoice-dialog-rectification.component";

import { ExpenseTabsComponent } from "./modules/expense/expense-tabs.component";
import { ExpenseSelectorComponent } from "./modules/expense/expenses/expense-selector.component";
import { ExpenseService } from "./modules/expense/expenses/expense.service";

import { FiscalTabsComponent } from "./modules/fiscalidad/fiscal-tabs.component";
import { FiscalModelComponent } from "./modules/fiscalidad/fiscalModels/fiscalModel.component";
import { FiscalService } from "./modules/fiscalidad/fiscal.service";

import { SalaryService } from "./modules/expense/salary/salary.service";


import { BankChargesService } from "./modules/expense/bankcharges/bankcharges.service";

import { FinancialIncomeService } from "./modules/invoice/financialincome/financialincome.service";

import { SubscriptionComponent } from "./modules/subscription/subscription.component";
import { SubscriptionService } from "./modules/subscription/subscription.service";
import { SubscriptionListComponent } from "./modules/subscription/subscriptionList.component";
import { BillingService } from "./modules/subscription/billing/billing.service";

import { ActivityService } from "./modules/user/activity/activity.service";

import { QRCodeService } from "./modules/qr/qrcode.service";
import { QRCodeOpenComponent } from "./modules/qr/qrcode-open.component";

import { InvestmentService } from "./modules/investment/investment.service";
import { InvestmentFormComponent } from "./modules/investment/intangible-material/investment-form.component";
import { InvestmenttabsComponent } from "./modules/investment/investment-tabs.component";

import { SubventionService } from "./modules/invoice/subvention/subvention.service";


import { TicketService } from "./modules/invoice/tickets/ticket.service";
import { TicketDialogTotalComponent } from "./modules/invoice/tickets/ticket-dialog-total.component";

import { AdvancePaymentService } from "./modules/expense/advancepayment/advancePayment.service";



import { UserTabsComponent } from "./modules/user/user-tabs.component";

import { CdkTableModule } from "@angular/cdk/table";

import { QRCodeComponent } from "angularx-qrcode";

import { NgxPaginationModule } from "ngx-pagination";

import { consts } from "../app/consts";

import { AdminService } from "./modules/admin/admin.service";
import { AdminListComponent } from "./modules/admin/users/admin-list.component";

import { ConceptImportComponent } from "./modules/concept/concept/concept-import.component";

import { ContactDialogTComponent } from "./modules/contact/contact/contact-dialog-t.component";

import { SelfEmployedService } from "./modules/expense/selfemployed/selfemployed.service";
import { CardModule } from "./shared/components/card/module";
import { DummyComponent } from "./shared/dummy.component";

import { NotificationService } from "./modules/notification/notification.service";
import { NotificationListComponent } from "./modules/notification/notification-list.component";

import { OcrHistoryService } from "./modules/ocrHistory/ocrHistory.service";
import { OcrHistoryComponent } from "./modules/ocrHistory/ocrHistory.component";
import { CheckoutService } from "./modules/subscription/stripe/checkout.service";
import { DragDropDirective } from "./shared/drag-drop.directive";
import { UploadFileComponent } from "./modules/file/upload-file.component";
import { AccountingModelService } from "./modules/user/accountingModel/accountingModel.service";
import { PrivacyDialogComponent } from "./shared/components/privacy-dialog/privacy-dialog.component";

import { ValidationService } from "./core/authentication/register/validation.service";
import { AdminTabsComponent } from "./modules/admin/admin-tabs.component";
import { SuscriptionAdminDialogComponent } from "./modules/admin/users/suscription-dialog.component";

import { MessageComponent } from "./shared/message/message.component";
import { HelpComponent } from "./shared/help/help.component";
import { HelpService } from "./modules/admin/help/help.service";
import { AdminHelpListComponent } from "./modules/admin/help/help-list.component";
import { AdminLogListComponent } from "./modules/admin/log/log-list.component";
import { AdminEventListComponent } from "./modules/admin/event/event-list.component";
import { AdminHelpComponent } from "./modules/admin/help/help.component";
import { AdminHelpFormComponent } from "./modules/admin/help/help-form.component";
import { AdminHelpDialogDeleteComponent } from "./modules/admin/help/help-dialog-delete.component";
import { ConsultantComponent } from "./modules/consultant/consultant.component";
import { ConsultantService } from "./modules/consultant/consultant.service";
import { ConsultantDialogDeleteComponent } from "./modules/consultant/consultant-dialog-delete.component";
import { PaginatorComponent } from "./shared/components/paginator/paginator.component";
import { AmortisationTableDialogComponent } from "./modules/investment/amortisation/table-dialog.component";
import { IrpfInvoiceListComponent } from "./modules/invoice/invoice/irpf-list.component";
import { FilesDialogDownloadComponent } from "./modules/file/files-dialog-download";
import { ImageZoomComponent } from "./shared/components/image-zoom/image-zoom.component";


import { NumberDecimalsDirective } from "./shared/NumberDecimalsDirective";
import { IntegerDirective } from "./shared/IntegerDirective";

import { ConfirmDialogComponent } from "./shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { DialogsService } from "./shared/components/dialogs/dialogs.service";
import { ConceptContactDialogDeleteComponent } from "./modules/concept/conceptcontact/conceptcontact-dialog-delete.component";
import { ResizeService } from "./core/size-detector/resize.service";
import { SizeDetectorComponent } from "./core/size-detector/size-detector.component";

import { QrZoomComponent } from "./shared/components/qr-zoom/qr-zoom.component";

import { AdminContactListComponent } from "./modules/admin/contact/admincontact-list.component";
import { AdminContactService } from "./modules/admin/contact/admincontact.service";
import { AdminContactImportComponent } from "./modules/admin/contact/admincontact-import.component";
import { SliceNamePipe } from "./shared/sliceName.pipe";
import { FirstStepsDialogComponent } from "./shared/components/first-steps-dialog/first-steps-dialog.component";
import { FirstStepsDialogService } from "./shared/components/first-steps-dialog/first-steps-dialog.service";
import { ReconciliationComponent } from "./modules/conciliation/reconciliation/reconciliation.component";
import { ReconciliationService } from "./modules/conciliation/reconciliation.service";
import { ReconciliationConnectComponent } from "./modules/conciliation/connect/reconciliation-connect.component";
import { ReconciliationTransactionsComponent } from "./modules/conciliation/transactions/reconciliation-transactions.component";
import { ReconciliationAutomaticComponent } from "./modules/conciliation/reconciliation-automatic/reconciliation-automatic.component";
import { ReconciliationReconcileComponent } from "./modules/conciliation/reconciliation-reconcile/reconciliation-reconcile.component";
import { AccountingTabsComponent } from "./modules/accounting/accounting-tabs.component";
import { AccountingMovementsListComponent } from "./modules/accounting/movements/accounting-movements-list.component";
import { AccountingMovementsService } from "./modules/accounting/movements/accounting-movements.service";
import { AccountingManualFormComponent } from "./modules/accounting/manual/accounting-manual-form.component";
import { TaxesTabsComponent } from "./modules/taxes/taxes-tabs.component";
import { Model421Component } from "./modules/taxes/indirectos/model-421/model-421.component";
// import { Model347Component } from "./modules/taxes/resumen-anual/model-347/model-347.component";
import { AccountingProfitAndLossComponent } from "./modules/accounting/reports/profitandloss/accounting-profitandloss.component";
import { AccountingReportsService } from "./modules/accounting/reports/accounting-reports.service";
import { AccountingBalanceSheetComponent } from "./modules/accounting/reports/balancesheet/accounting-balancesheet.component";
import { AccountingAccountsService } from "./modules/accounting/accounting-accounts/accounting-accounts.service";
import { AccountingAccountsComponent } from "./modules/accounting/accounting-accounts/accounting-accounts.component";
import { AccountingAccountsDialogDeleteComponent } from "./modules/accounting/accounting-accounts/accounting-accounts-dialog-delete.component";
import { AccountingAccountsFormComponent } from "./modules/accounting/accounting-accounts/accounting-accounts-form.component";
import { AccountingAccountsListComponent } from "./modules/accounting/accounting-accounts/accounting-accounts-list.component";
import { AccountingAccountsDialogLedgerComponent } from "./modules/accounting/accounting-accounts/accounting-accounts-dialog-ledger.component";
import { ControlStockComponent } from "./modules/concept/controlstock/controlstock.component";
import { ControlStockListComponent } from "./modules/concept/controlstock/controlstock-list.component";
import { ControlStockFormComponent } from "./modules/concept/controlstock/controlstock-form.component";
import { ControlStockDialogDeleteComponent } from "./modules/concept/controlstock/controlstock-dialog-delete.component";
import { ControlStockService } from "./modules/concept/controlstock/controlstock.service";
import { StatisticsService } from "./modules/statistics/statistics.service";
import { InvoiceStatisticsComponent } from "./modules/invoice/invoices-statistics/invoices-statistics.component";
import { TaxesModelsService } from "./modules/taxes/taxes-models.service";
import { InvestmentDialogPayComponent } from "./modules/investment/intangible-material/investment-dialog-pay.component";
import { InvestmentInCompaniesService } from "./modules/investment/incompanies/investment-incompanies.service";
import { InvestmentInCompaniesDialogPayComponent } from "./modules/investment/incompanies/investment-incompanies-dialog-pay.component";
import { InvestmentInCompaniesFormComponent } from "./modules/investment/incompanies/investment-incompanies-form.component";
import { InvestmentFinancialService } from "./modules/investment/financial/investment-financial.service";
import { InvestmentFinancialFormComponent } from "./modules/investment/financial/investment-financial-form.component";
import { InvestmentPropertyService } from "./modules/investment/property/investment-property.service";
import { InvestmentPropertyDialogPayComponent } from "./modules/investment/property/investment-property-dialog-pay.component";
import { InvestmentPropertyFormComponent } from "./modules/investment/property/investment-property-form.component";
import { EmployeesListComponent } from "./modules/employees/employees-list.component";
import { EmployeesDialogDeleteComponent } from "./modules/employees/employees-dialog-delete.component";
import { EmployeesFormComponent } from "./modules/employees/employees-form.component";
import { SalaryDepositsService } from "./modules/expense/salary/salary-deposits.service";
import { CreditosConEmpleadosService } from "./modules/finanzas/creditos-con-empleados/creditos-con-empleados.service";
import { CreditosConEmpleadosComponent } from "./modules/finanzas/creditos-con-empleados/creditos-con-empleados.component";
import { FinanzastabsComponent } from "./modules/finanzas/finanzas-tabs.component";
import { CreditosConEmpleadosFormComponent } from "./modules/finanzas/creditos-con-empleados/creditos-con-empleados-form.component";
import { CreditosService } from "./modules/finanzas/creditos/creditos.service";
import { CreditosComponent } from "./modules/finanzas/creditos/creditos.component";
import { CreditosFormComponent } from "./modules/finanzas/creditos/creditos-form.component";
import { FinanciacionPrivadaDialogAttachmentComponent } from "./modules/finanzas/financiacion-privada/financiacion-privada-dialog-attachment.component";
import { FinanciacionPrivadaDialogPagoCuotasComponent } from "./modules/finanzas/financiacion-privada/financiacion-privada-dialog-pago-cuotas.component";
import { FinanciacionPrivadaDialogDeudaACortoPlazoComponent } from "./modules/finanzas/financiacion-privada/financiacion-privada-dialog-deuda-a-corto-plazo.component";
import { FinanciacionPrivadaDialogConstitucionComponent } from "./modules/finanzas/financiacion-privada/financiacion-privada-dialog-constitucion.component";
import { FinanciacionPrivadaService } from "./modules/finanzas/financiacion-privada/financiacion-privada.service";
import { FinanciacionPrivadaComponent } from "./modules/finanzas/financiacion-privada/financiacion-privada.component";
import { FinanciacionPrivadaFormComponent } from "./modules/finanzas/financiacion-privada/financiacion-privada-form.component";

// #region Personal
import { AsuntosPropiosModule } from "./modules/employees/asuntos-propios/asuntos-propios.module";
import { BajasModule } from "./modules/employees/bajas/bajas.module";
import { EmployeesModule } from "./modules/employees/employees.module";
import { ServicesModule } from "./services/services.module";
import { GastosModule } from "./modules/employees/gastos/gastos.module";
import { TurnosModule } from "./modules/employees/turnos/turnos.module";
import { VacacionesModule } from "./modules/employees/vacaciones/vacaciones.module";
import { TiempoModule } from "./modules/employees/tiempo/tiempo.module";
// #endregion

// #region Gastos - IA
import { IAModule } from "./modules/expense/ia/ia.module";
// #endregion

// #region Gastos - Correos IA
import { CorreosIAModule } from "./modules/expense/correos-ia/correos-ia.module";
// #endregion

// #region Gastos - Ficheros - Datos extra
import { FileDataExtraModule } from "./modules/expense/file-data-extra/fileDataExtra.module";
// #endregion

import { FinanciacionPropiaComponent } from "./modules/finanzas/financiacion-propia/financiacion-propia.component";
import { FinanciacionPropiaFormComponent } from "./modules/finanzas/financiacion-propia/financiacion-propia-form.component";
import { FinanciacionPropiaDialogAttachmentComponent } from "./modules/finanzas/financiacion-propia/financiacion-propia-dialog-attachment.component";
import { FinanciacionPropiaDialogPagoCuotasComponent } from "./modules/finanzas/financiacion-propia/financiacion-propia-dialog-pago-cuotas.component";
import { FinanciacionPropiaDialogDeudaACortoPlazoComponent } from "./modules/finanzas/financiacion-propia/financiacion-propia-dialog-deuda-a-corto-plazo.component";
import { FinanciacionPropiaDialogConstitucionComponent } from "./modules/finanzas/financiacion-propia/financiacion-propia-dialog-constitucion.component";
import { FinanciacionPropiaService } from "./modules/finanzas/financiacion-propia/financiacion-propia.service";
import { PrestamosComponent } from "./modules/finanzas/prestamos/prestamos.component";
import { PrestamosFormComponent } from "./modules/finanzas/prestamos/prestamos-form.component";
import { PrestamosService } from "./modules/finanzas/prestamos/prestamos.service";
import { PartnersequityComponent } from "./modules/user/partnersequity/partnersequity.component";
import { PartnersListComponent } from "./modules/user/partnersequity/partners/partners-list.component";
import { PartnersDialogDeleteComponent } from "./modules/user/partnersequity/partners/partners-dialog-delete.component";
import { PartnersFormComponent } from "./modules/user/partnersequity/partners/partners-form.component";
import { PartnersFormTransactionsComponent } from "./modules/user/partnersequity/partners/partners-form-transactions.component";
import { SocialCapitalListComponent } from "./modules/user/partnersequity/social-capital/social-capital-list.component";
import { SocialCapitalFormComponent } from "./modules/user/partnersequity/social-capital/social-capital-form.component";
import { SocialCapitalDeleteComponent } from "./modules/user/partnersequity/social-capital/social-capital-delete.component";
import { ReserveListComponent } from "./modules/user/partnersequity/reserve/reserve-list.component";
import { ReserveFormComponent } from "./modules/user/partnersequity/reserve/reserve-form.component";
import { ReserveDeleteComponent } from "./modules/user/partnersequity/reserve/reserve-delete.component";
import { RelatedCompaniesListComponent } from "./modules/user/partnersequity/related-companies/related-companies-list.component";
import { RelatedCompaniesFormComponent } from "./modules/user/partnersequity/related-companies/related-companies-form.component";
import { RelatedCompaniesDeleteComponent } from "./modules/user/partnersequity/related-companies/related-companies-delete.component";
import { RelatedCompaniesFormTransactionsComponent } from "./modules/user/partnersequity/related-companies/related-companies-form-transactions.component";
import { RelatedCompaniesDialogTComponent } from "./modules/user/partnersequity/related-companies/related-companies-dialog-t.component";
import { Model425Component } from "./modules/taxes/indirectos/model-425/model-425.component";
import { SupportTicketsService } from "./modules/supportTickets/tickets.service";
import { SupportTicketsComponent } from "./modules/supportTickets/tickets.component";
import { SupportTicketsConversationComponent } from "./modules/supportTickets/tickets-conversation.component";
import { SupportTicketsDialogComponent } from "./modules/supportTickets/tickets-dialog.component";
import { AccountingMovementsImportComponent } from "./modules/accounting/movements/import/accounting-movements-import.component";

import { EfectivoService } from "./services/finanzas/efectivo/efectivo.service";
import { EfectivoDialogFormComponent } from "./modules/finanzas/efectivo/efectivo-dialog-form.component";
import { EfectivoDialogIngresoACajaComponent } from "./modules/finanzas/efectivo/efectivo-dialog-ingreso-a-caja.component";
import { EfectivoDialogMovimientoSocioComponent } from "./modules/finanzas/efectivo/efectivo-dialog-movimiento-socio.component";
import { PolizaCreditoService } from "./services/finanzas/poliza-credito/poliza-credito.service";
import { CreditosTabsComponent } from "./modules/finanzas/creditos-tabs/creditos-tabs.component";
import { PrestamosTabsComponent } from "./modules/finanzas/prestamos-tabs/prestamos-tabs.component";
import { BankAccountsDialogMovimientoBancoComponent } from "./modules/finanzas/bancos/bankaccount-dialog-movimiento-banco.component";
import { BankAccountsDialogMovimientoEfectivoComponent } from "./modules/finanzas/bancos/bankaccount-dialog-movimiento-efectivo.component";

import { ChartResumeTotalComponent } from "./modules/resume/charts/chart-resume-total/chart-resume-total.component";
import { ChartResumeIgicComponent } from "./modules/resume/charts/chart-resume-igic/chart-resume-igic.component";
import { ChartResumeIVAComponent } from "./modules/resume/charts/chart-resume-iva/chart-resume-iva.component";
import { ChartResumeEarningComponent } from "./modules/resume/charts/chart-resume-earning/chart-resume-earning.component";
import { ChartResumePaidedComponent } from "./modules/resume/charts/chart-resume-paided/chart-resume-paided.component";
import { PaymentCardDialogMovimientoTarjetaCreditoComponent } from "./modules/finanzas/paymentcard/tarjeta-credito/paymentcard-dialog-movimiento-tarjeta-credito.component";
import { AdvancePaymentTabsComponent } from "./modules/expense/advancepayment-tabs/advancepayment-tabs.component";
import { BailService } from "./modules/expense/bail/bail.service";

import { AccountingMovementsImportDialog } from "./modules/accounting/movements/import/accounting-movements-import-dialog";
import { SharedService } from "./shared/services/shared.service";
import { AccountingSumasySaldosComponent } from "./modules/accounting/reports/sumasysaldos/accounting-sumasysaldos.component";
import { ResumeResultComponent } from "./modules/resume/resume-result/resume-result.component";
import { ReportTabsComponent } from "./modules/accounting/reports/report-tabs/report-tabs.component";
import { ReportWorkingCapitalComponent } from "./modules/accounting/reports/report-working-capital/report-working-capital.component";
import { ReportTotalComponent } from "./modules/accounting/reports/report-total/report-total.component";
import { ReportGrossMarginComponent } from "./modules/accounting/reports/report-gross-margin/report-gross-margin.component";
import { ReportCashFlowComponent } from "./modules/accounting/reports/report-cash-flow/report-cash-flow.component";
import { ReportRatioComponent } from "./modules/accounting/reports/report-ratio/report-ratio.component";
import { ValueService } from "./shared/value.service";
import { QuarterlyTaxReceiptListComponent } from "./modules/taxes/quarterly-tax-receipt/quarterly-tax-receipt-list/quarterly-tax-receipt-list.component";
import { QuarterlyTaxReceiptService } from "./modules/taxes/quarterly-tax-receipt/quarterly-tax-receipt.service";
import { QuarterlyTaxReceiptFormComponent } from "./modules/taxes/quarterly-tax-receipt/quarterly-tax-receipt-edit/quarterly-tax-receipt-edit.component";
import { QuarterlyTaxReceiptComponent } from "./modules/taxes/quarterly-tax-receipt/quarterly-tax-receipt.component";
import { PrestamosDialogImportAccount } from "./modules/finanzas/prestamos/prestamos-dialog-importAccount.component";
import { InvestmentDialogImportAccount } from "./modules/investment/intangible-material/investment-dialog-importAccount.component";
import { InvestmentPropertyDialogImportAccount } from "./modules/investment/property/investmentProperty-dialog-importAccount.component";
import { InvestmentInCompaniesDialogImportAccount } from "./modules/investment/incompanies/investmentInCompanies-dialog-importAccount.component";
import { InvestmentFinancialDialogImportAccount } from "./modules/investment/financial/investmentFinancial-dialog-importAccount.component";
import { BankAccountDialogImportAccount } from "./modules/finanzas/bancos/bankaccount-dialog-importAccount.component";
import { PaymentCardDialogImportAccount } from "./modules/finanzas/paymentcard/paymentcard-dialog-importAccount.component";
import { FinanciacionPropiaDialogImportAccount } from "./modules/finanzas/financiacion-propia/financiacion-propia-dialog-importAccount.component";
import { FinanciacionPrivadaDialogImportAccount } from "./modules/finanzas/financiacion-privada/financiacion-privada-dialog-importAccount.component";
import { QuarterlyTaxReceiptDialogDeleteComponent } from "./modules/taxes/quarterly-tax-receipt/quarterly-tax-receipt-dialog-delete.component";
import { AnnualSumaryTabsComponent } from "./modules/taxes/annual-summary-tabs/annual-summary-tabs.component";
import { ContactPropertyService } from "./modules/contact/contact/contact-property.service";
import { ContactPropertyFormComponent } from "./modules/contact/contact-property/contact-property-form.component";
import { TaxesTabService } from "./modules/taxes/taxes-tabs.service";
import { ModelTaxService } from "./modules/taxes/model-tax.service";
import { HeaderTabService } from "./shared/components/header-tabs/header-tab.service";
import { EmployeestabsComponent } from "./modules/employees/employees-tabs.component";
import { AccountingImbalanceDialogComponent } from "./modules/accounting/accounting-imbalance/accounting-imbalance-dialog.component";
import { ReconciliationActionsComponent } from "./modules/conciliation/actions/reconciliation-actions.component";
import { BankChargesDialogFormComponent } from "./modules/expense/bankcharges/modal-form/bankcharges-dialog.component";
import { ConsultantDialogAccountingReportsComponent } from "./modules/consultant/accounting-reports/consultant-dialog-accounting-reports.component";
import { Model184Component } from "./modules/taxes/model-184/model-184.component";
import { Model184RentasComponent } from "./modules/taxes/model-184/model-184-rentas/model-184-rentas.component";
import { Model184MiembrosComponent } from "./modules/taxes/model-184/model-184-miembros/model-184-miembros.component";
import { Model184RentaDialogComponent } from "./modules/taxes/model-184/model-184-renta-dialog/model-184-renta-dialog.component";
import { Model184MiembroDialogComponent } from "./modules/taxes/model-184/model-184-miembro-dialog/model-184-miembro-dialog.component";
import { Model180Component } from "./modules/taxes/model-180/model-180.component";
import { Model180RecipientsComponent } from "./modules/taxes/model-180/model-180-recipients/model-180-recipients.component";
import { Model180RecipientDialogComponent } from "./modules/taxes/model-180/model-180-recipient-dialog/model-180-recipient-dialog.component";
import { Model193Component } from "./modules/taxes/model-193/model-193.component";
import { Model193RecipientsComponent } from "./modules/taxes/model-193/model-193-recipients/model-193-recipients.component";
import { Model193RecipientDialogComponent } from "./modules/taxes/model-193/model-193-recipient-dialog/model-193-recipient-dialog.component";
import { Model182Component } from "./modules/taxes/model-182/model-182.component";
import { Model182DeclaradosComponent } from "./modules/taxes/model-182/model-182-declarados/model-182-declarados.component";
import { Model182DeclaradoDialogComponent } from "./modules/taxes/model-182/model-182-declarado-dialog/model-182-declarado-dialog.component";
import { TaxesSharedModule } from "./modules/taxes/taxes-shared.module";
import { DialogWorkingComponent } from "./shared/components/dialog-working/dialog-working.component";
import { UserExportComponent } from "./modules/user/export/user-export.component";
import { ReconciliationPolizaCreditoService } from "./modules/conciliation/reconciliation-poliza-credito.service";
import { AccountingImportComponent } from "./modules/accounting/import/accounting-import.component";
import { AccountingExportComponent } from "./modules/accounting/export/accounting-export.component";
import { CenteredDialogComponent } from "./shared/components/centered-dialog/centered-dialog.component";
import { DialogService } from "./shared/services/dialog.service";
import { YearlyUpgradeDialogComponent } from "./modules/subscription/yearly-upgrade-dialog/yearly-upgrade-dialog.component";
import { MonthlyDowngradeDialogComponent } from "./modules/subscription/monthly-downgrade-dialog/monthly-downgrade-dialog.component";
import { CancelAccountDialogComponent } from "./modules/subscription/cancel-account-dialog/cancel-account-dialog.component";
import { ReactivateAccountDialogComponent } from "./modules/subscription/reactivate-account-dialog/reactivate-account-dialog.component";
import { PaymentIssueDialogComponent } from "./shared/components/payment-issue-dialog/payment-issue-dialog.component";
import { OcrProgressPanelComponent } from "./shared/components/ocr-progress-panel/ocr-progress-panel.component";
import { RebrandIntroSplashComponent } from "./shared/components/rebrand-intro-splash/rebrand-intro-splash.component";
import { PaymentHistoryDialogComponent } from "./modules/subscription/payment-history-dialog/payment-history-dialog.component";
import { ContactSalesDialogComponent } from "./modules/subscription/contact-sales-dialog/contact-sales-dialog.component";
import { ConfirmPlanDialogComponent } from "./modules/subscription/confirm-plan-dialog/confirm-plan-dialog.component";
import { PlanChangePreviewComponent } from "./modules/subscription/plan-change-preview/plan-change-preview.component";
import { AddCouponDialogComponent } from "./modules/subscription/add-coupon-dialog/add-coupon-dialog.component";
import { OcrPurchaseDialogComponent } from "./modules/subscription/ocr-purchase-dialog/ocr-purchase-dialog.component";
import { BookingSubscriptionActivationDialogComponent } from "./modules/subscription/booking-subscription-activation-dialog/booking-subscription-activation-dialog.component";
import { TpvSubscriptionActivationDialogComponent } from "./modules/subscription/tpv-subscription-activation-dialog/tpv-subscription-activation-dialog.component";
import { BookingActivationRequiredDialogComponent } from "./modules_v2/booking/components/booking-activation-required-dialog/booking-activation-required-dialog.component";
import { BankTransactionImportImportComponent } from "./modules/conciliation/import/bank-transaction-import.component";
import { UserFirstTimeActionService } from "./modules/user/user-first-time-action/user-first-time-action.service";
import { UserFirstTimeNewPreinvoceDialogComponent } from "./modules/user/user-first-time-action/user-first-time-new-preinvoice/user-first-time-new-preinvoice.component";
import { UserFirstTimeNewExpenseDialogComponent } from "./modules/user/user-first-time-action/user-first-time-new-expense/user-first-time-new-expense.component";
import { AutocompleteSelectModule } from "./shared/components/autocomplete-select/autocomplete-select.module";
import { MessagingService } from "./modules/subscription/stripe/messaging.service";
import { SharedModule } from "./shared/shared.module";
import { BarcodeDialogComponent } from "./modules/invoice/preinvoice/barcode-dialog.component";
import { PreinvoiceDialogWorkOrderComponent } from "./modules/invoice/preinvoice/preinvoice-dialog-work-order.component";
import { InvoiceDialogVerifactuComponent } from "./modules/invoice/invoice/invoice-dialog-verifactu.component";
import { ConceptSerialNumberComponent } from "./modules/concept/concept/serialNumber/concept-serialNumber.component";
import { AdvisorService } from "./modules/advisor/advisor.service";
import { AdvisorModule } from "./modules/advisor/advisor.module";
import { FiscalClosureListComponent } from "./modules/taxes/fiscal-closure/fiscal-closure-list/fiscal-closure-list.component";
import { AdvisorListComponent } from "./modules/advisor/advisor-list.component";
import { AdvisorFormComponent } from "./modules/advisor/advisor-form.component";
import { AdvisorDialogDeleteComponent } from "./modules/advisor/advisor-dialog-delete.component";
import { AssignAdvisorComponent } from "./modules/admin/users/assign-advisor-dialog.component";
import { ViewModule } from "./shared/view/view.module";
import { AdminUserCommentsComponent } from "./modules/admin/users/admin-user-comments-dialog.component";
import { ContactModule } from "./modules_v2/contacts/contacts.module";
import { VerifactuService } from "./modules_v2/verifactu/services/verifactu.service";
import { AdminModule } from "./modules_v2/admin/admin.module";
import { AdminVerifactuService } from "./modules_v2/admin/services/admin-verifactu.service";
import { UserSessionsComponent } from "./modules/user/userSessions/userSessions.component";
import { ChildUsersService } from "./modules/employees/childUsers/child-users.service";
import { ChildUsersComponent } from "./modules/employees/childUsers/child-users.component";
import { UnauthorizedComponent } from "./guards/permission/unauthorized.component";
import { ActionReducerMap, StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { AuthInterceptor } from "./core/guards/auth/auth.interceptor";

export interface AppState { }
export const ROOT_REDUCERS: ActionReducerMap<AppState> = {};
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ConfirmDialogV2 } from "./modules_v2/shared/components/confirm-dialog.component";

import { CalendarModule } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { DragDropModule } from '@angular/cdk/drag-drop';

import { CalendarComponent } from "./modules/schedule/calendar.component";
import { NewEventDialogComponent } from "./modules/schedule/new-event-dialog.component";
import { ScheduleListComponent } from "./modules/schedule/schedule-list.component";
import { ScheduleService } from "./modules/schedule/schedule.service";
import { ScheduleDetailsDialogComponent } from "./modules/schedule/schedule-details-dialog.component";
import { PreinvoiceScheduleWrapperComponent } from "./modules/schedule/preinvoice-schedule-wrapper.component";
import { InvoiceDialogProjectComponent } from "./modules/invoice/invoice/invoice-dialog-project.component";
import { FormShellComponent } from "./modules_v2/shared/components/form-shell/form-shell.component";
import { BookingModule } from "./modules_v2/booking/booking.module";
import { TicketModule } from "./modules_v2/income/ticket/ticket.module";
import { EmailDialogComponent } from "./modules/invoice/tickets/email-dialog.component";
import { ImportSumasSaldosComponent } from "./modules/accounting/import/import-sumas-saldos.component";
import { FilesDialogMoveComponent } from "./modules/file/files-dialog-move.component";
import { FilesDialogRepairComponent } from "./modules/file/files-dialog-repair.component";
import { UiFormModule } from "./shared/ui/ui-form.module";
import { SharedModule as SharedModuleV2 } from "./modules_v2/shared/shared.module";
import { AiChatModule } from "./modules_v2/ia/ai-chat.module";
import { RecurrentModule } from "./modules_v2/income/recurrent/recurrent.module";
import { GrantModule } from "./modules_v2/income/grant/grant.module";
import { CustomerAdvancePaymentModule } from "./modules_v2/income/customer-advance-payment/customer-advance-payment.module";
import { FinancialIncomeModule } from "./modules_v2/income/financial-income/financial-income.module";
import { BankAccountModule } from "./modules_v2/finance/bank-account/bank-account.module";
import { CashModule } from "./modules_v2/finance/cash/cash.module";
import { CreditPolicyModule } from "./modules_v2/finance/credit-policy/credit-policy.module";
import { PaymentCardV2Module } from "./modules_v2/finance/payment-card/payment-card.module";
import { LoanModule } from "./modules_v2/finance/loan/loan.module";
import { OwnFinancingModule } from "./modules_v2/finance/own-financing/own-financing.module";
import { PrivateFinancingModule } from "./modules_v2/finance/private-financing/private-financing.module";
import { CreditModule } from "./modules_v2/finance/credit/credit.module";
import { EmployeeCreditModule } from "./modules_v2/finance/employee-credit/employee-credit.module";
import { FinancialInvestmentModule } from "./modules_v2/investment/financial-investment/financial-investment.module";
import { InvestmentAssetIntangibleModule } from "./modules_v2/investment/investment-asset-intangible/investment-asset-intangible.module";
import { InvestmentAssetMaterialModule } from "./modules_v2/investment/investment-asset-material/investment-asset-material.module";
import { InvestmentCompanyModule } from "./modules_v2/investment/investment-company/investment-company.module";
import { RealStateInvestmentModule } from "./modules_v2/investment/real-state-investment/real-state-investment.module";
import { LocationsModule } from "./modules_v2/booking/locations/locations.module";
import { ConceptDialogSalesComponent } from "./modules/concept/concept/concept-dialog-sales.component";
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';

@NgModule({
    declarations: [
        TableComponent,
        AddFileComponent,
        FilterPipe,
        SliceNamePipe,
        AppComponent,
        NotFoundComponent,
        RegisterComponent,
        PrivacyDialogComponent,
        LoginComponent,
        LogoutComponent,
        ForgotComponent,
        DevelopersComponent,
        CodeBlockComponent,
        FirstStepsDialogComponent,
        CoreComponent,
        ResumeComponent,
        ResumeResultComponent,
        ResumeDialogComponent,
        BalanceDialogComponent,
        HelpTabsComponent,
        EntranceHelpComponent,
        ExpenseHelpComponent,
        BankAccountHelpComponent,
        ConceptTabsComponent,
        BookingConceptSyncDialogComponent,
        ConceptImportComponent,
        ConfirmDialogComponent,
        ConceptContactComponent,
        ConceptContactFormComponent,
        ConceptContactListComponent,
        ConceptContactDialogDeleteComponent,
        ConceptSerialNumberComponent,
        ContactListComponent,
        ContactTabsComponent,
        ContactInvoicesComponent,
        ContactDialogDeleteComponent,
        ContactImportComponent,
        ContactDialogTComponent,
        BookingContactSyncDialogComponent,
        CenterListComponent,
        CenterComponent,
        CenterFormComponent,
        PreinvoiceListComponent,
        PreinvoiceFormComponent,
        PreinvoiceFormItemComponent,
        PreinvoiceDialogDeleteComponent,
        UserLogoComponent,
        UserBillingListComponent,
        UserStockComponent,
        UserStockFormComponent,
        UserStockLoginComponent,
        FilesListComponent,
        FilesDialogComponent,
        FilesDialogFileComponent,
        FilesDialogEditComponent,
        FilesDialogDeleteComponent,
        FilesDialogDownloadComponent,
        FilesDialogMoveComponent,
        FilesDialogRepairComponent,
        FiscalTabsComponent,
        FiscalModelComponent,
        BankAccountListComponent,
        BankAccountComponent,
        BankAccountFormComponent,
        ContactBankAccountListComponent,
        ContactBankAccountComponent,
        ContactBankAccountFormComponent,
        InvoiceListIssuedComponent,
        InvoiceTabsComponent,
        BookingTabsComponent,
        InvoiceDialogPaidedComponent,
        InvoiceDialogSepaComponent,
        InvoiceDialogFacturaEComponent,
        InvoiceDialogVerifactuComponent,
        InvoiceDialogRectificationComponent,
        PreinvoiceDialogWorkOrderComponent,
        ExpenseTabsComponent,
        ExpenseSelectorComponent,
        ConboxDialogComponent,
        SubscriptionComponent,
        SubscriptionListComponent,
        //Projects
        InvoiceDialogProjectComponent,
        InvestmentFormComponent,
        InvestmenttabsComponent,
        AmortisationTableDialogComponent,
        InvestmentDialogPayComponent,
        InvestmentDialogImportAccount,
        IrpfInvoiceListComponent,
        UserTabsComponent,
        QRCodeOpenComponent,
        ChipsComponent,
        CenteredDialogComponent,
        UserFirstTimeNewPreinvoceDialogComponent,
        UserFirstTimeNewExpenseDialogComponent,
        AdminListComponent,
        AdminTabsComponent,
        EmployeestabsComponent,
        SuscriptionAdminDialogComponent,
        TicketDialogTotalComponent,
        EmailDialogComponent,
        AdvisorListComponent,
        AdvisorFormComponent,
        AdvisorDialogDeleteComponent,
        AssignAdvisorComponent,
        PaymentCardFormComponent,
        PaymentCardComponent,
        DummyComponent,
        NotificationListComponent,
        OcrHistoryComponent,
        DragDropDirective,
        UploadFileComponent,
        MessageComponent,
        // HelpComponent,
        AdminHelpListComponent,
        AdminHelpComponent,
        AdminHelpFormComponent,
        AdminHelpDialogDeleteComponent,
        AdminLogListComponent,
        AdminEventListComponent,
        AdminContactListComponent,
        AdminContactImportComponent,
        ConsultantComponent,
        ConsultantDialogDeleteComponent,
        PaginatorComponent,
        ImageZoomComponent,
        QrZoomComponent,
        NumberDecimalsDirective,
        IntegerDirective,
        SizeDetectorComponent,
        ReconciliationComponent,
        ReconciliationConnectComponent,
        ReconciliationTransactionsComponent,
        ReconciliationAutomaticComponent,
        ReconciliationReconcileComponent,
        //tpv
        AccountingTabsComponent,
        AccountingMovementsListComponent,
        AccountingManualFormComponent,
        AccountingProfitAndLossComponent,
        AccountingBalanceSheetComponent,
        AccountingAccountsDialogDeleteComponent,
        AccountingAccountsDialogLedgerComponent,
        AccountingAccountsComponent,
        AccountingAccountsFormComponent,
        AccountingAccountsListComponent,
        AccountingMovementsImportComponent,
        AccountingMovementsImportDialog,
        AccountingSumasySaldosComponent,
        ImportSumasSaldosComponent,
        AccountingImportComponent,
        AccountingExportComponent,
        TaxesTabsComponent,
        Model421Component,
        ControlStockComponent,
        ControlStockListComponent,
        ControlStockFormComponent,
        ControlStockDialogDeleteComponent,
        InvoiceStatisticsComponent,
        InvestmentInCompaniesFormComponent,
        InvestmentInCompaniesDialogPayComponent,
        InvestmentFinancialFormComponent,
        QuarterlyTaxReceiptListComponent,
        QuarterlyTaxReceiptFormComponent,
        QuarterlyTaxReceiptComponent,
        QuarterlyTaxReceiptDialogDeleteComponent,
        InvestmentPropertyFormComponent,
        InvestmentPropertyDialogPayComponent,
        EmployeesListComponent,
        EmployeesDialogDeleteComponent,
        EmployeesFormComponent,
        FinanzastabsComponent,
        CreditosConEmpleadosComponent,
        CreditosConEmpleadosFormComponent,
        CreditosComponent,
        CreditosFormComponent,
        FinanciacionPrivadaComponent,
        FinanciacionPrivadaFormComponent,
        FinanciacionPrivadaDialogAttachmentComponent,
        FinanciacionPrivadaDialogPagoCuotasComponent,
        FinanciacionPrivadaDialogDeudaACortoPlazoComponent,
        FinanciacionPrivadaDialogConstitucionComponent,
        FinanciacionPropiaComponent,
        FinanciacionPropiaFormComponent,
        FinanciacionPropiaDialogAttachmentComponent,
        FinanciacionPropiaDialogPagoCuotasComponent,
        FinanciacionPropiaDialogDeudaACortoPlazoComponent,
        FinanciacionPropiaDialogConstitucionComponent,
        PrestamosComponent,
        PrestamosFormComponent,
        PrestamosDialogImportAccount,
        PartnersequityComponent,
        PartnersListComponent,
        PartnersDialogDeleteComponent,
        PartnersFormComponent,
        PartnersFormTransactionsComponent,
        SocialCapitalListComponent,
        SocialCapitalFormComponent,
        SocialCapitalDeleteComponent,
        ReserveListComponent,
        ReserveFormComponent,
        ReserveDeleteComponent,
        RelatedCompaniesListComponent,
        RelatedCompaniesFormComponent,
        RelatedCompaniesDeleteComponent,
        RelatedCompaniesFormTransactionsComponent,
        RelatedCompaniesDialogTComponent,
        EfectivoDialogFormComponent,
        EfectivoDialogIngresoACajaComponent,
        EfectivoDialogMovimientoSocioComponent,
        CreditosTabsComponent,
        PrestamosTabsComponent,
        AdvancePaymentTabsComponent,
        BankAccountsDialogMovimientoBancoComponent,
        BankAccountsDialogMovimientoEfectivoComponent,
        ChartResumeTotalComponent,
        ChartResumeIgicComponent,
        ChartResumeIVAComponent,
        ChartResumePaidedComponent,
        ChartResumeEarningComponent,
        PaymentCardDialogMovimientoTarjetaCreditoComponent,
        SupportTicketsComponent,
        SupportTicketsConversationComponent,
        SupportTicketsDialogComponent,
        ReportWorkingCapitalComponent,
        ReportTotalComponent,
        ReportGrossMarginComponent,
        ReportCashFlowComponent,
        ReportRatioComponent,
        ReportTabsComponent,
        AnnualSumaryTabsComponent,
        InvestmentPropertyDialogImportAccount,
        InvestmentInCompaniesDialogImportAccount,
        InvestmentFinancialDialogImportAccount,
        BankAccountDialogImportAccount,
        PaymentCardDialogImportAccount,
        FinanciacionPropiaDialogImportAccount,
        FinanciacionPrivadaDialogImportAccount,
        ContactPropertyFormComponent,
        AccountingImbalanceDialogComponent,
        ReconciliationActionsComponent,
        BankChargesDialogFormComponent,
        ConsultantDialogAccountingReportsComponent,
        Model184Component,
        Model184RentasComponent,
        Model184MiembrosComponent,
        Model184RentaDialogComponent,
        Model184MiembroDialogComponent,
        Model180Component,
        Model180RecipientsComponent,
        Model180RecipientDialogComponent,
        Model193Component,
        Model193RecipientsComponent,
        Model193RecipientDialogComponent,
        Model182Component,
        Model182DeclaradosComponent,
        Model182DeclaradoDialogComponent,
        DialogWorkingComponent,
        UserExportComponent,
        YearlyUpgradeDialogComponent,
        MonthlyDowngradeDialogComponent,
        CancelAccountDialogComponent,
        ReactivateAccountDialogComponent,
        PaymentIssueDialogComponent,
        RebrandIntroSplashComponent,
        OcrProgressPanelComponent,
        PaymentHistoryDialogComponent,
        ContactSalesDialogComponent,
        ConfirmPlanDialogComponent,
        PlanChangePreviewComponent,
        AddCouponDialogComponent,
        OcrPurchaseDialogComponent,
        BookingSubscriptionActivationDialogComponent,
        TpvSubscriptionActivationDialogComponent,
        BookingActivationRequiredDialogComponent,
        BankTransactionImportImportComponent,
        BarcodeDialogComponent,
        FiscalClosureListComponent,
        AdminUserCommentsComponent,
        UserSessionsComponent,
        ChildUsersComponent,
        UnauthorizedComponent,
        ConfirmDialogV2,
        ScheduleListComponent,
        CalendarComponent,
        NewEventDialogComponent,
        ScheduleDetailsDialogComponent,
        PreinvoiceScheduleWrapperComponent,
        // FormShellComponent
        ConceptDialogSalesComponent
    ],
    exports: [
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        CdkTableModule,
        MatStepperModule,
        MatSortModule,
        MatTableModule,
        MatPaginatorModule,
        MatTabsModule,
        CdkTableModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDividerModule,
        MatStepperModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatExpansionModule,
        ViewModule,
        ContactModule,
        AdminModule,
        ConfirmDialogV2,
        AutocompleteSelectModule
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [
        HeaderTabsModule,
        UiFormModule,
        TaxesSharedModule,
        SharedModuleV2,
        RecurrentModule,
        GrantModule,
        CustomerAdvancePaymentModule,
        FinancialIncomeModule,
        BankAccountModule,
        CashModule,
        CreditPolicyModule,
        PaymentCardV2Module,
        LoanModule,
        OwnFinancingModule,
        PrivateFinancingModule,
        CreditModule,
        EmployeeCreditModule,
        FinancialInvestmentModule,
        InvestmentAssetIntangibleModule,
        InvestmentAssetMaterialModule,
        InvestmentCompanyModule,
        RealStateInvestmentModule,
        LocationsModule,
        BaseChartDirective,
        NgxExtendedPdfViewerModule,
        MatProgressSpinnerModule,
        BrowserModule,
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatIconModule,
        MatInputModule,
        MatSnackBarModule,
        MatDatepickerModule,
        MatSelectModule,
        MatNativeDateModule,
        MatCheckboxModule,
        FormsModule,
        RouterModule.forRoot(CONVFACT_ROUTES, { preloadingStrategy: PreloadAllModules }),
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatStepperModule,
        MatSelectModule,
        MatCardModule,
        MatMenuModule,
        MatChipsModule,
        MatSlideToggleModule,
        MatTabsModule,
        MatRadioModule,
        NgxPaginationModule,
        MatDialogModule,
        MatTableModule,
        MatSortModule,
        BrowserAnimationsModule,
        MatTooltipModule,
        QRCodeComponent,
        CardModule,
        NgxExtendedPdfViewerModule,
        MatPaginatorModule,
        EmployeesModule,
        GastosModule,
        TurnosModule,
        BajasModule,
        AsuntosPropiosModule,
        VacacionesModule,
        TiempoModule,
        IAModule,
        CorreosIAModule,
        AiChatModule,
        FileDataExtraModule,
        PaginationModule,
        SharedModule,
        AdvisorModule,
        ViewModule,
        BookingModule,
        TicketModule,
        StoreModule.forRoot(ROOT_REDUCERS),
        EffectsModule.forRoot([]),
        StoreDevtoolsModule.instrument({ maxAge: 25 }),
        CalendarModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        DragDropModule,
        AutocompleteSelectModule],
    providers: [
        provideZoneChangeDetection({ eventCoalescing: false, runCoalescing: false }),
        { provide: MAT_DATE_LOCALE, useValue: "es-ES" },
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { ...SNACK_BAR_POSITION } },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        provideCharts(withDefaultRegisterables()),
        AuthService,
        AuthGuard,
        DialogService,
        ActivateService,
        ContactService,
        ContactPropertyService,
        CenterService,
        ConceptFamilyService,
        ConceptService,
        ConceptContactService,
        PreinvoiceService,
        UserContactService,
        UserCompanyService,
        UserStockService,
        UserFirstTimeActionService,
        VerifactuService,
        AdminVerifactuService,
        BankAccountService,
        ContactBankAccountService,
        InvoiceService,
        DeliveryNoteService,
        QRCodeService,
        ResumeService,
        CoreService,
        QuarterlyTaxReceiptService,
        FilesService,
        ActivityService,
        FiscalService,
        SubscriptionService,
        BillingService,
        UserService,
        InvestmentService,
        SubventionService,
        MatDialog,
        TicketService,
        AdvancePaymentService,
        PaymentCardService,
        AdvisorService,
        ExpenseService,
        TaxCalculator,
        SalaryService,
        SelfEmployedService,
        BailService,
        DummyComponent,
        { provide: DateAdapter, useClass: MyDateAdapter },
        { provide: LOCALE_ID, useValue: "es-ES" },
        { provide: consts, useValue: consts },
        {
            provide: SubscriptionListComponent,
            useClass: SubscriptionListComponent,
        },
        AdminService,
        AddFileService,
        NotificationService,
        CoreComponent,
        OcrHistoryService,
        CheckoutService,
        MessagingService,
        AccountingModelService,
        ValidationService,
        HelpService,
        AdminContactService,
        ValidationService,
        ConsultantService,
        ConsultantService,
        DialogsService,
        ResizeService,
        FirstStepsDialogService,
        BankChargesService,
        FinancialIncomeService,
        ReconciliationService,
        AccountingMovementsService,
        AccountingReportsService,
        AccountingAccountsService,
        ControlStockService,
        StatisticsService,
        TaxesModelsService,
        InvestmentInCompaniesService,
        InvestmentFinancialService,
        InvestmentPropertyService,
        SalaryDepositsService,
        CreditosConEmpleadosService,
        CreditosService,
        FinanciacionPrivadaService,
        FinanciacionPropiaService,
        PrestamosService,
        ServicesModule,
        EfectivoService,
        PolizaCreditoService,
        SupportTicketsService,
        ModelTaxService,
        ValueService,
        SharedService,
        TaxesTabService,
        HeaderTabService,
        ReconciliationPolizaCreditoService,
        ChildUsersService,
        ScheduleService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {
    constructor(private dateAdapter: DateAdapter<Date>) {
        this.dateAdapter.setLocale("es-ES");
    }
}
